<template>
  <div>
    <b-modal
      id="seproban_images"
      ref="seproban_images"
      size="md"
      hide-header
      hide-footer
      centered
      no-close-on-backdrop
      no-close-on-esc
      @show="onShowImages"
      @hide="onCloseImages"
    >
      <div class="col-md-12">
        <div class="text-center mb-1">
          Alarma creada: {{ alarm.created_format_1 }}
        </div>
        <b-row>
          <b-col cols="6" class="mb-2" v-if="$can('filter_datetime', 'Alarm')">
            <label class="text-capitalize">
              {{ $t("alarm.start_date_filter") }}
            </label>
            <flat-pickr
              class="form-control"
              :config="{
                enableTime: true,
                enableSeconds: true,
                dateFormat: 'Y-m-d H:i:s',
                time_24hr: true,
                minuteIncrement: 1,
                secondIncrement: 1,
              }"
              :value="startDatetime"
              @on-change="onStartDateSelected"
            />
          </b-col>
          <b-col cols="6" class="mb-2" v-if="$can('filter_datetime', 'Alarm')">
            <label class="text-capitalize">
              {{ $t("alarm.end_date_filter") }}
            </label>
            <flat-pickr
              class="form-control"
              :config="{
                enableTime: true,
                enableSeconds: true,
                dateFormat: 'Y-m-d H:i:s',
                time_24hr: true,
                minuteIncrement: 1,
                secondIncrement: 1,
              }"
              :value="endDatetime"
              @on-change="onEndDateSelected"
            />
          </b-col>
        </b-row>
      </div>
      <div
        v-if="isAlarmAlreadyLoaded(alarm.id)"
        class="d-flex justify-content-end align-items-center gap-2"
      >
        <b-button variant="secondary" size="sm" @click="onCancel()">
          {{ $t("grid.modals.alarms_status.btns.cancel") }}
        </b-button>

        <b-button
          :id="`button-${alarm.id}`"
          variant="primary"
          size="sm"
          class="ml-1"
          @click="submit"
          :disabled="!isStartBeforeEnd"
        >
          Generar Imagenes
        </b-button>
      </div>
      <div v-if="canCreateEvent">
        <send-to-seproban :alarm-id="alarm.id" usage-type="modal" />
        <div  class="d-flex justify-content-end align-items-center gap-2">
          <b-button variant="secondary" size="sm" @click="onCancel()">
            {{ $t("grid.modals.update_layout.btns.ok") }}
          </b-button>
        </div>
      </div>
      <div v-if="validating" class="text-center py-3">
        <b-spinner v-if="!message" label="Cargando..."></b-spinner>
        <p class="mt-1">
          {{ message === "" ? "Validando evento..." : message }}
        </p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BSpinner,
  BForm,
  BFormGroup,
  BFormTextarea,
  BFormSelect,
  BButton,
} from "bootstrap-vue";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import store from "@/store";
import axios from "@/libs/axios";
import { ref, computed } from "@vue/composition-api";
import flatPickr from "vue-flatpickr-component";
import moment from "moment-timezone";
import SendToSeproban from "./SendToSeproban.vue";

export default {
  components: {
    BSpinner,
    BForm,
    BFormGroup,
    BFormTextarea,
    BFormSelect,
    BButton,
    ValidationProvider,
    ValidationObserver,
    flatPickr,
    SendToSeproban,
  },
  setup() {
    const send_to_seproban_modal = ref(null);
    const fetchList = ref([]);
    const camerasId = ref([]);
    const startDatetime = ref("");
    const startDate = ref("");
    const endDatetime = ref("");
    const endDate = ref("");
    const alarm = ref([]);
    const toast = useToast();
    const seproban_images = ref(null);
    const filteredCameras = ref([]);
    const user = store.getters["user/getUser"];
    const canCreateEvent = ref(false);
    const message = ref("");
    const validating = ref(false);
    const totalImages = ref(0);

    const onShowImages = async () => {
      canCreateEvent.value = false;
      message.value = "";
      camerasId.value = [];
      alarm.value = store.state.grid.selectedAlarm.alarm;
      fetchList.value = alarm.value.cameras;
      totalImages.value = 0

      const dateCreated = alarm.value.created_format_1;
      const date = moment(dateCreated, "DD/MM/YYYY HH:mm:ss");
      const dataBefore = date.clone().subtract(1, "minutes");
      const dateAfter = date.clone().add(1, "minutes");

      startDate.value = dataBefore.format("YYYY-MM-DD HH:mm:ss");
      endDate.value = dateAfter.format("YYYY-MM-DD HH:mm:ss");
      startDatetime.value = startDate.value;
      endDatetime.value = endDate.value;

      fetchList.value.forEach((camera) => {
        if (camera && camera.send_to_seproban) {
          camerasId.value.push(camera.id_camera_proxy);
        }
      });

      /*//const success  = await submit();
      if (!success) {
        return;
      }

      const filtered = fetchList.value.filter(
        (cam) => cam && camerasId.value.includes(cam.camera_proxy_id)
      );

      const cameras = filtered.map((cam) => ({
        camera_proxy_id: cam.camera_proxy_id,
        camera_name: cam.name,
        download_progress: 0,
        upload_progress: 0,
        images: [],
      }));

      const alarmId = alarm.value.id;
      const unitName = alarm.value.unit.description;
      const created = alarm.value.created;
      store.commit("send_to_seproban/initAlarm", {
        alarmId: alarmId,
        unitName: unitName,
        created: created,
      });
      store.commit("send_to_seproban/setFilteredCameras", {
        alarmId: alarmId,
        cameras: cameras,
      });

      setSnapshotsDownloadSeprobanWS();
      */
    };

    const isAlarmAlreadyLoaded = (alarmId) => {
      const alarms = store.state.send_to_seproban.items.alarms || [];
      return !alarms.some((alarm) => alarm.id_alarm === alarmId);
    };

    const isStartBeforeEnd = computed(() => {
      if (!startDate.value || !endDate.value) return false;
      const start = moment(startDate.value, "YYYY-MM-DD HH:mm:ss");
      const end = moment(endDate.value, "YYYY-MM-DD HH:mm:ss");
      return start.isBefore(end);
    });

    const initAlarmStore = (seprobanAlarmId = null) => {
      const start = moment(startDate.value, "YYYY-MM-DD HH:mm:ss");
      const end = moment(endDate.value, "YYYY-MM-DD HH:mm:ss");
      const totalSeconds = Math.abs(end.diff(start, 'seconds'));
      const intervalSeconds = 2;
      totalImages.value = Math.max(1, Math.floor(totalSeconds / intervalSeconds) + 1);

      const filtered = fetchList.value.filter(
        (cam) => cam && camerasId.value.includes(cam.camera_proxy_id)
      );

      const cameras = filtered.map((cam) => ({
        camera_proxy_id: cam.camera_proxy_id,
        camera_name: cam.name,
        download_progress: 0,
        upload_progress: 0,
        images: [],
      }));

      const alarmId = alarm.value.id;
      const unitName = alarm.value.unit.description;
      const created = alarm.value.created;
      console.log("seprobanAlarmId", seprobanAlarmId)
      store.commit("send_to_seproban/initAlarm", {
        alarmId: alarmId,
        id_seproban_alarm: seprobanAlarmId,
        unitName: unitName,
        created: created,
        totalImages: totalImages.value * cameras.length
      });
      store.commit("send_to_seproban/setFilteredCameras", {
        alarmId: alarmId,
        cameras: cameras,
      });
    };

    const submit = async () => {
      if (camerasId.value.length === 0) {
        return;
      }

      validating.value = true; 
      let params = {
        ids_camera_proxy: camerasId.value,
        start_date: startDate.value,
        end_date: endDate.value,
        id_alarm: alarm.value.id,
      };

      try {
        const response = await axios.post(
          "/v1/seproban/snapshots/download",
          params
        );
        if (response.data.success === false) {
          message.value = response.data.message;
          canCreateEvent.value = false;
          return false;
        }
        validating.value = false;
        canCreateEvent.value = true;
        const seprobanAlarm = response.data.data || response.data;

        const seprobanAlarmId =
          seprobanAlarm.id_seproban_alarm_event ??
          seprobanAlarm.id_seproban_alarm ??
          seprobanAlarm.seproban_alarm_id ??
          seprobanAlarm.id ??
          seprobanAlarm.event.id ??
          null;
        initAlarmStore(seprobanAlarmId);
        setSnapshotsDownloadSeprobanWS();
        return true;
      } catch (error) {
        validating.value = false;
        canCreateEvent.value = false;
        return false;
      }
    };

    const setSnapshotsDownloadSeprobanWS = () => {
      window.Echo.leave(`snapshots-download-seproban-${user.id}-${alarm.value.id}`);

      window.Echo.private(`snapshots-download-seproban-${user.id}-${alarm.value.id}`).listen(
        ".process",
        (data) => {
          //const hasImageFile = /\.(jpg|jpeg)$/i.test(data.image_url);
          if (data.image_url) {
            store.commit("send_to_seproban/updateDownloadData", {
              alarmId: data.alarm_id,
              cameraId: data.camera_proxy_id,
              imageUrl: data.image_url,
              progress: data.progress,
              timestamp: data.timestamp,
            });
          }
        }
      );
    };

    const resetDataModal = () => {
      store.dispatch("grid/unsetSelectedAlarm");
      camerasId.value = [];
      startDate.value = "";
      endDate.value = "";
    };

    const closeModal = () => {
      resetDataModal();
      seproban_images.value.hide();
    };

    const onCancel = () => {
      closeModal();
    };

    const onCloseImages = () => {
      validating.value = false
      store.commit("send_to_seproban/setNotification", true);
    };

    const onStartDateSelected = ([dateStr]) => {
      startDate.value = moment(dateStr).format("YYYY-MM-DD HH:mm:ss");
    };

    const onEndDateSelected = ([dateStr]) => {
      endDate.value = moment(dateStr).format("YYYY-MM-DD HH:mm:ss");
    };

    return {
      //MODAL CAMARAS
      send_to_seproban_modal,
      alarm,
      fetchList,
      camerasId,
      startDatetime,
      endDatetime,
      startDate,
      endDate,
      submit,
      resetDataModal,
      closeModal,
      onCancel,
      message,
      canCreateEvent,

      validating,
      isStartBeforeEnd,
      onStartDateSelected,
      onEndDateSelected,
      isAlarmAlreadyLoaded,
      //MODAL OBTENIENDO IMAGENES
      seproban_images,
      onShowImages,
      onCloseImages,
      filteredCameras,
    };
  },
};
</script>
